<template>
    <vx-modal :visible="props.visible" @update:visible="emit('update:visible', $event)" :padding="false" size="sm">
        <template v-slot:header>
            <div class="px-12 pt-12">Rename Section</div>
        </template>

        <div class="font-sans pt-4 px-12 pb-12">
            <vx-input
                :modelValue="props.modelValue"
                @update:modelValue="emit('update:modelValue', $event)"
                size="lg"
                @keyup.enter="update"
                :error="displayFirstError(validation.name.$errors)"
            ></vx-input>

            <vx-button
                @click.prevent="update"
                :loading="submitting"
                data-test="save-button"
                block
                type="button"
                size="lg"
                color="primary"
                class="mt-4 lg:mt-6"
            >
                Update
            </vx-button>
        </div>
    </vx-modal>
</template>

<script setup>
import { VxButton, VxInput, VxModal } from '@voxie/frontend-components';
import useVuelidate from '@vuelidate/core';
import { maxLength, required } from '@vuelidate/validators';
import { computed, ref } from 'vue';
import { alphanumericDashUnderscoreSpace, displayFirstError, validateRules } from '~/utils/validation';
import { useCustomFlow } from './useCustomFlow';
import { useFormRequestHandler } from '~/composables/useFormRequestHandler';

const props = defineProps({
    visible: {
        type: Boolean,
        required: true,
    },
    modelValue: {
        type: String,
        required: true,
    },
});

const { $externalResults, catchError } = useFormRequestHandler();
const emit = defineEmits(['update:visible', 'update:modelValue']);

const submitting = ref(false);

const validation = useVuelidate(
    {
        name: {
            required,
            maxLength: maxLength(80),
            regex: alphanumericDashUnderscoreSpace,
        },
    },
    computed(() => ({ name: props.modelValue })),
    { $externalResults }
);

const { saveSections, sections } = useCustomFlow();

const update = async () => {
    const isValid = await validateRules(validation);
    if (submitting.value || !isValid) {
        return;
    }

    try {
        submitting.value = true;
        await saveSections(sections.value);

        emit('update:visible', false);
    } catch (e) {
        catchError(e);
    } finally {
        submitting.value = false;
    }
};
</script>
